import { AfterViewInit, ChangeDetectorRef, Directive, HostListener, Input, OnInit, Renderer2 } from '@angular/core';
import { DomController } from '@ionic/angular';
import { PaymentsService } from '../payments.service';
import { DataService } from '../services/data.service';

@Directive({
  selector: '[appHideHeader]'
})
export class HideHeaderDirective  {
  @Input('appHideHeader') public header:any;
  toolbar;
  scrollTop=0
  private toolbarHeight=44;
  constructor(
    private dataSRV:DataService,
    public paymentSRV:PaymentsService,
    private changeDetectorRef: ChangeDetectorRef,
    private renderer:Renderer2,
    private domCtrl:DomController) { }

    ngAfterViewInit() {
      this.domCtrl.read(()=>{
        this.toolbar = this.header.toolbar
        
        
      })
    }
    @HostListener('ionScroll',['$event']) onContentScroll($event){
    if(this.dataSRV.isAuthenticated.value == true && this.paymentSRV.showReceipt.value==false && this.paymentSRV.processingPayment.value==false && this.dataSRV.isTemp==false){
      let newPosition;
     
      if(this.scrollTop > $event.detail.scrollTop){
        
        newPosition = 0
        this.scrollTop =  $event.detail.scrollTop
      } else {
        
        this.scrollTop =  $event.detail.scrollTop
       newPosition = - (this.scrollTop / 5)
      }
      
      let newOpacity = 1 - (newPosition / -this.toolbarHeight)
      this.domCtrl.read(()=>{
        this.toolbar = this.header.toolbar
        this.domCtrl.write(()=>{
          this.renderer.setStyle(this.toolbar.nativeElement,'top',`${newPosition}px`)
          this.renderer.setStyle(this.toolbar.nativeElement,'opacity',newOpacity)
      })
        
      })
    }
      
       
     
      
    }
}
